import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { queryKeys } from '../react-query.config';
import { toast } from 'sonner';

interface DeleteQuestionResponse {
  success: boolean;
}

export const deleteQuestion = (questionId: string): Promise<DeleteQuestionResponse> =>
  api.delete(`/questions/${questionId}`);

export const useDeleteQuestionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteQuestion,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.questions.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.pickems.all });
      toast.success('Question deleted successfully');
    },
    onError: (error: { message?: string }) => {
      toast.error(error.message || 'Failed to delete question');
    },
  });
};
